import { IBcfImportState } from './interfaces/IBcfImportState';

export const bcfImportSelector = (state: any): IBcfImportState => state.bcfImport;

export const selectedFileSelector = (state: any): File | undefined => state.bcfImport.selectedFile;

export const fileAnalysisResultSelector = (state: any) => state.bcfImport.fileAnalysisResult;

export const currentStepSelector = (state: any) => state.bcfImport.currentStep;

export const mappingConfigsSelector = (state: any) => state.bcfImport.mappingConfigs;

export const importSettingsSelector = (state: any) => state.bcfImport.importSettings;

export const importPreviewSelector = (state: any) => state.bcfImport.importPreview;

export const importResultSelector = (state: any) => state.bcfImport.importResult;

export const isLoadingSelector = (state: any) => state.bcfImport.isLoading;

export const isSavingSelector = (state: any) => state.bcfImport.isSaving;

export const importProgressSelector = (state: any) => state.bcfImport.importProgress;

export const errorSelector = (state: any) => state.bcfImport.error;

export const successMessageSelector = (state: any) => state.bcfImport.successMessage;

export const isStepValidSelector = (state: any) => state.bcfImport.isStepValid;
